import {ReadFavItemsQuery, ReadFavItemsMsg} from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import {FAV_ITEM_DETAIL_MAP} from '../../store/Constants';
import Store from '../../store/Store';

export default class ReadFavItems {
  constructor() {    
  }

  run() {
   return new Promise((onSuccess, onFailure) => {     
    const query = new ReadFavItemsQuery();
    const msg = new ReadFavItemsMsg();
    query.message = msg;
    query.run().then(
      (resp) => {
        if (onSuccess)
          onSuccess(resp);
        Store.put(FAV_ITEM_DETAIL_MAP, resp.getFuid2FavItemObject());
        //window.gs.fuid2FavItemDetailMap = resp.getFuid2FavItemObject();
        // window.render();
      },
      (error) => {
        ErrorHandler.handleError(error);
        if (onFailure)
           onFailure(error);    
      }
    );  
  }); 
 }
}